<template>
    <div class="privacy-page">
        <GallabLogo class="logo" />
        <div class="header">
            <h1>Polityka prywatności</h1>
            <button class="select-button" @click="goToConfigurator">
                Przejdź do konfiguratora
            </button>
        </div>

        <div v-if="privacyTexts.length" class="content-container">
            <section v-for="text in privacyTexts" :key="text.id">
                <!-- <h2 v-html="text.name"></h2> -->
                <p v-html="text.content"></p>
            </section>
        </div>

        <section v-else>
            <p>Brak treści</p>
        </section>
    </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useTextsStore } from '@/stores/textsStore'
import GallabLogo from '@/components/common/GallabLogo.vue'

export default {
    name: 'PrivacyPage',
    components: {
        GallabLogo,
    },
    methods: {
        goToConfigurator() {
            this.$router.push('/')
        },
    },
    setup() {
        const textsStore = useTextsStore()

        onMounted(() => {
            textsStore.fetchTexts()
        })

        const privacyTexts = computed(() =>
            textsStore.texts.filter(text => text.page_area === 'Polityka prywatności')
        )

        return {
            privacyTexts,
        }
    },
}
</script>

<style scoped lang="scss">
.privacy-page {
    max-width: 1000px;
    margin: 0 auto;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
    line-height: 1.6;
    color: $color-text;
    min-height: 100vh;
    margin-bottom: 100px;

    h1 {
        font-size: 1.7rem;
        margin: 24px 0;
        color: $color-primary;
        width: 400px;
        padding-left: 20px;
        background: $color-primary;
        color: $color-white;
        clip-path: polygon(20px 50%,
                0 0,
                calc(100% - 20px) 0,
                100% 50%,
                calc(100% - 20px) 100%,
                0 100%,
                0 0);
    }

    h2 {
        font-size: 1.25rem;
        margin-top: 1.5rem;
        color: $color-text;
    }

    section p {
        margin-top: 0.5rem;
        font-size: 1rem;
        color: $color-text-light;
        text-align: justify;
    }
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 2rem;
}

.select-button {
    width: 200px;
    height: 50px;
    padding: 8px 0;
    background-color: transparent;
    border: 1px solid $color-primary;
    border-radius: 4px;
    color: $color-primary;
    font-weight: 500;
    font-size: 0.85rem;
    cursor: pointer;
    margin-bottom: 10px;
    transition: all 0.25s ease;

    &:hover {
        background-color: $color-primary;
        color: $color-white;
    }
}

.content-container {
    background-color: white;
    padding: 40px;
    border-radius: 8px;
    opacity: 0.8;
}
</style>
